import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import {
  CarouselItemDynamicComponent,
  CarouselStepContent,
  CarouselStepStyle,
} from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';
import { Variant3Component } from './variant3/variant3.component';
import { Variant4Component } from './variant4/variant4.component';
import { Variant5Component } from './variant5/variant5.component';
import { Variant6Component } from './variant6/variant6.component';

@Component({
  imports: [NgComponentOutlet],
  selector: 'b2c-carousel-item',
  templateUrl: './carousel-item.component.html',
})
export class CarouselItemComponent extends BaseComponent {
  stepContent = input.required<CarouselStepContent>();

  protected variant =
    this.loyaltyChallengeConfig.components.tutorial.carousel.items.variant;

  protected carouselItemStyle: CarouselStepStyle =
    this.loyaltyChallengeConfig.components.tutorial.carousel.items.styles;

  protected components: Signal<CarouselItemDynamicComponent> = computed(() => {
    return {
      [this.Variants.VARIANT_1]: {
        component: Variant1Component,
        inputs: {
          stepContent: this.stepContent(),
          itemStyle: this.carouselItemStyle,
        },
      },
      [this.Variants.VARIANT_2]: {
        component: Variant2Component,
        inputs: {
          stepContent: this.stepContent(),
          itemStyle: this.carouselItemStyle,
        },
      },
      [this.Variants.VARIANT_3]: {
        component: Variant3Component,
        inputs: {
          stepContent: this.stepContent(),
          itemStyle: this.carouselItemStyle,
        },
      },
      [this.Variants.VARIANT_4]: {
        component: Variant4Component,
        inputs: {
          stepContent: this.stepContent(),
          itemStyle: this.carouselItemStyle,
        },
      },
      [this.Variants.VARIANT_5]: {
        component: Variant5Component,
        inputs: {
          stepContent: this.stepContent(),
          itemStyle: this.carouselItemStyle,
        },
      },
      [this.Variants.VARIANT_6]: {
        component: Variant6Component,
        inputs: {
          stepContent: this.stepContent(),
          itemStyle: this.carouselItemStyle,
        },
      },
    };
  });
}
